require.register("attachment/controllers/newCtrl", function(exports, require, module){
  $0
  
});

